<template>
  <div
    class="row-timeline-container"
    :class="{
      'on-hold': isOnHold(),
      'failed-delivery': isFailed(),
      'successful-delivery': isSuccessful(),
    }"
  >
    <div
      class="row-timeline-item"
      v-for="statusStep in timelineSteps"
      :key="statusStep.key"
      :class="{
        active: isActive(statusStep.key),
        inactive: isInactive(statusStep.key),
      }"
    >
      <div class="row-timeline-dot"></div>
      <div class="row-timeline-label">{{ statusStep.label }}</div>
      <div class="row-timeline-time">
        {{
          modelValue[statusStep.key] !== null
            ? formatDate(modelValue[statusStep.key])
            : "-"
        }}
      </div>
      <div
        v-if="statusStep !== timelineSteps[timelineSteps.length - 1]"
        class="row-timeline-connector"
      ></div>
    </div>
  </div>
</template>

<script>
import date from "@/modules/date";

export default {
  props: {
    modelValue: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      timelineSteps: [
        { key: "packaged_at", label: "Packaged" },
        { key: "tracking_code_created_at", label: "Tracking Created" },
        { key: "posted_at", label: "Posted" },
        { key: "drop_off_at", label: "Drop-off" },
        { key: "delivered_at", label: "Delivered" },
        { key: "refused_at", label: "Refused" },
      ],
    };
  },
  methods: {
    formatDate(val, time = true, relative = true) {
      return date.format(val, time, relative);
    },
    isInactive(key) {
      const item = this.modelValue;

      if (key === "drop_off_at" && item.type !== 2) {
        return true;
      }

      if (key === "delivered_at" && item.refused_at) {
        return true;
      }

      if (key === "refused_at" && !item.refused_at) {
        return true;
      }

      return false;
    },
    isOnHold() {
      return this.modelValue.status == 4;
    },
    isFailed() {
      return this.modelValue.refused_at !== null;
    },
    isSuccessful() {
      return this.modelValue.delivered_at !== null;
    },
    isActive(key) {
      return !!this.modelValue[key];
    },
  },
};
</script>

<style scoped>
.row-timeline-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 1em;
}

.row-timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-width: 80px;
  flex: 1 1 0;
}

@media screen and (min-width: 1700px) {
  .row-timeline-item {
    min-width: 140px;
  }
}

.row-timeline-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #ccc;
  z-index: 1;
}

.row-timeline-item.active .row-timeline-dot {
  background-color: #025bb3;
}

.row-timeline-container.on-hold .row-timeline-item.active .row-timeline-dot {
  background-color: #d8d800;
}
.row-timeline-container.failed-delivery
  .row-timeline-item.active
  .row-timeline-dot {
  background-color: #d80000;
}

.row-timeline-container.successful-delivery
  .row-timeline-item.active
  .row-timeline-dot {
  background-color: #1c9236;
}

.row-timeline-item.inactive .row-timeline-dot {
  background-color: #f3f3f3;
}

.row-timeline-label {
  margin-top: 6px;
  font-size: 0.8rem;
  text-align: center;
}

.row-timeline-time {
  margin-top: 2px;
  font-size: 0.7rem;
  color: #666;
  text-align: center;
}

.row-timeline-item.inactive .row-timeline-label {
  color: #a3a3a3;
}

.row-timeline-connector {
  position: absolute;
  top: 7px;
  left: calc(50% + 12px);
  height: 2px;
  width: calc(100% - 16px);
  background-color: #ccc;
  z-index: 0;
}
</style>
